//background-video-alt-img

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll("video.section-video img").forEach(function(img) {
    if (!img.hasAttribute("alt")) {
      img.setAttribute("alt", "Video thumbnail image");
    }
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const lazyVideos = document.querySelectorAll("video.section-video");

  const videoObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const source = video.querySelector("source");
        if (source && source.src) {
          video.play(); // load the video
        }
        observer.unobserve(video);
      }
    });
  }, { threshold: 0.25 }); // when 25% visible

  lazyVideos.forEach(video => {
    videoObserver.observe(video);
  });

});


document.addEventListener("DOMContentLoaded", function () {
  if(window.innerWidth <= 768) {
    document.querySelectorAll('.product-blocks__block--accordion-item .js-accordion-header').forEach((header)=>{
      header.setAttribute('aria-expanded', 'false');
    })
    document.querySelectorAll('.product-blocks__block--accordion-item .c-accordion__panel').forEach((header)=>{
      header.classList.remove('is-active'); 
    })
  }
});